var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AMisRenderer',{attrs:{"schema":_vm.schema}})
}
var staticRenderFns = []

export { render, staticRenderFns }